
import { Button } from "@/components/ui/button";
import { Tables } from "@/integrations/supabase/types";

type Quote = Tables<'quotes'>;

interface QuoteActionButtonsProps {
  quote: Quote;
  canInteractWithQuotes: boolean;
  isAdminViewingOthersBooking: boolean;
  loadingQuoteId: string | null;
  generatingPayment: string | null;
  onQuoteResponse: (quoteId: string, action: 'accepted' | 'rejected', response?: string) => void;
}

const QuoteActionButtons = ({
  quote,
  canInteractWithQuotes,
  isAdminViewingOthersBooking,
  loadingQuoteId,
  generatingPayment,
  onQuoteResponse
}: QuoteActionButtonsProps) => {
  return (
    <div className="flex gap-2 mt-3 justify-end">
      <Button 
        size="sm" 
        variant="outline" 
        onClick={() => canInteractWithQuotes ? onQuoteResponse(quote.id, 'rejected', 'Quote declined') : undefined} 
        disabled={!canInteractWithQuotes || loadingQuoteId === quote.id || !!generatingPayment} 
        className={`border-red-300 text-red-600 hover:bg-red-50 w-full ${!canInteractWithQuotes ? 'opacity-60 cursor-not-allowed' : ''}`}
        title={isAdminViewingOthersBooking ? 'Read-only: Admin viewing another user\'s booking' : ''}
      >
        Decline
      </Button>
      <Button 
        size="sm" 
        onClick={() => canInteractWithQuotes ? onQuoteResponse(quote.id, 'accepted', 'Quote accepted') : undefined} 
        disabled={!canInteractWithQuotes || loadingQuoteId === quote.id || !!generatingPayment} 
        className={`bg-green-600 hover:bg-green-700 text-white w-full ${!canInteractWithQuotes ? 'opacity-60 cursor-not-allowed' : ''}`}
        title={isAdminViewingOthersBooking ? 'Read-only: Admin viewing another user\'s booking' : ''}
      >
        Accept and Pay
      </Button>
    </div>
  );
};

export default QuoteActionButtons;
